
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 500 500"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"helix-back",attrs:{"d":"M103.4 129.7c-3.7 0-6.7 3-6.7 6.7v33.9h13.4v-33.9c0-3.7-3-6.7-6.7-6.7z"}}),_c('path',{staticClass:"helix-base-1",attrs:{"d":"M103.4 129.7c-3.7 0-6.7 3-6.7 6.7v33.9h13.4v-33.9c0-3.7-3-6.7-6.7-6.7z"}}),_c('path',{staticClass:"helix-base-2",attrs:{"d":"M371.4 129.7c3.7 0 6.7 3 6.7 6.7v33.9h-13.4v-33.9c0-3.7 3-6.7 6.7-6.7z"}}),_c('path',{staticClass:"body",attrs:{"d":"M378.1 170.2h-74.7c-7.9 0-15.3-3.5-20.4-9.4l-10.7-12.6c-5.1-6-12.6-9.4-20.4-9.4h-28.8c-7.9 0-15.3 3.5-20.4 9.4L192 160.8c-5.1 6-12.6 9.4-20.4 9.4H96.7c-7.4 0-13.4 6-13.4 13.4 0 7.3 5.9 13.3 13.3 13.3H132c3.1 0 6.1 1.1 8.5 3.1l23.1 19.1h6.7l18.8 28.3c5 7.5 13.3 11.9 22.3 11.9h51.8c9 0 17.3-4.5 22.3-11.9l18.8-28.3h6.7l23.1-19.1c2.4-2 5.4-3.1 8.5-3.1h35.5c7.3 0 13.3-5.9 13.3-13.3.1-7.4-5.9-13.4-13.3-13.4z"}}),_c('path',{staticClass:"helix-left-1",attrs:{"d":"M99.2 138.6l4.2 4.7-19.9 8.7-47.1-6.7v-6.7z"}}),_c('path',{staticClass:"helix-left-2",attrs:{"d":"M107.6 138.6l-4.2-4.7 19.9-8.7 47.1 6.7v6.7z"}}),_c('path',{staticClass:"helix-right-1",attrs:{"d":"M367.2 138.6l4.2 4.7-19.9 8.7-47.1-6.7v-6.7z"}}),_c('path',{staticClass:"helix-right-2",attrs:{"d":"M375.6 138.6l-4.2-4.7 19.9-8.7 47.1 6.7v6.7z"}})])
          )
        }
      }
    